import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function OsnoviEkonomije() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Osnovi ekonomije" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Osnovi ekonomije</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Osnovi ekonomije
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 7
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Osnovi ekonomije studentima omogućavaju sticanje osnovnog
                ekonomskog znanja iz oblasti mikroekonomije ekonomike
                blagostanja makroekonomije međunarodne ekonomije i ekonomske
                teorije koje je neophodno radi uspešnog učestvovanja u
                ekonomskom životu. Takođe cilj je i sticanje znanja vezana uz
                funkcinisanje tržišta u Evropskoj uniji globalizaciju tržišta
                kao i trenodve u globalnoj ekonomiji. Strategija održivog
                razvoja kao globalna ekonomska strategija izučavaće se u
                funkciji nacionalnog razvoja crnogorske ekonomije a sa tim
                vezano i znanja o regulisanju tržišta i cijena.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Po položenom ispitu student će moći: da navede osnovne vrste
                mikroekonomije i makroekonomije kao i konkurentskih tržišta;
                utvrditi glavnu problematiku ekonomski pitanja u savremenom
                svijetu kao i načine njihovog rješavnja; pratiti i
                implementirati glavne trendove razvoja svjetske ekonomije.
                Takođe studenti će steći neophodno ekonomsko znanjr radi
                donošenja optimalnih ekonomskih odluka. Poznavanje bitnih
                ekonomskih kategorija zakona i teorija u cilju efikasnog
                učestvovanja u ekonomskom životu.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                Uvod: Predmet ekonomije; Metod ekonomije; Odnos ekonomije i
                drugih društvenih nauka; Pomoćne discipline u ekonomskoj
                analizi; Pojam društvene proizvodnje; Komponente društvene
                proizvodnje; Determinante društvene proizvodnje; Oblici
                društvene proizvodnje; Uloga države u privredi; (a)
                Mikroekonomija: Predmet mikroekonomije; Metod mikroekonomije;
                Osnovni regulator robne privrede; Parcijalna ekonomska
                ravnoteža; Proizvodnja i troškovi proizvodnje; Maksimizacija
                profita; Potpuna konkurencija; Monopol; Monopolistička
                konkurencija; Oligopol; Tržišta faktora priozvodnje; Suočavanje
                sa rizikom u ekonomskom životu; (b) Ekonomika blagostanja:
                Tržišta sa asimetričnim informacijama; Eksterni efekti i javno
                dobro; Opšta ekonomska ravnoteža i ekonomska efikasnost – od
                mikroekonomije ka makroekonomiji; (v) Makroekonomija:
                Makroekonomski agregati; Agregatna ponuda i agregatna tražnja;
                Novac i inflacija; Budžetski deficit i nacionalni dug; Privredni
                ciklusi i nezaposlenost; Ekonomski rast; (g) Međunarodna
                ekonomija: Međunarodna trgovina; Međunarodni monetarni sistem i
                međunarodne finansije; Ekonomski razvoj razvijene i nerazvijene
                zemlje; (d) Ekonomska teorija: Klasična ekonomija; Neoklasična
                ekonomija; Kejnzijanizam; Monetarizam; Nova klasična
                makroekonomija; Savremeni pravci ekonomske teorije.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Predavanja. Interaktivna nastava. Diskusija. Konsultacije.
                Vežbe. Kolokvijum. Testovi.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>2P</td>
                    <td>
                      Predmet ekonomije; Metod ekonomije; Odnos ekonomije i
                      drugih društvenih nauka; Pomoćne discipline u ekonomskoj
                      analizi
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>2P</td>
                    <td>
                      Pojam društvene proizvodnje; Komponente društvene
                      proizvodnje; Determinante društvene proizvodnje; Oblici
                      društvene proizvodnje
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>2P</td>
                    <td>Uloga države u privredi</td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>2P</td>
                    <td>
                      Mikroekonomija: Predmet mikroekonomije; Metod
                      mikroekonomije; Osnovni regulator robne privrede;
                      Parcijalna ekonomska ravnoteža; Proizvodnja i troškovi
                      proizvodnje; Maksimizacija profita
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>2P</td>
                    <td>
                      Potpuna konkurencija; Monopol; Monopolistička
                      konkurencija; Oligopol; Tržišta faktora priozvodnje;
                      Suočavanje sa rizikom u ekonomskom životu; Ekonomika
                      blagostanja: Tržišta sa asimetričnim informacijama;
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>Kolokvijum I</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>2P</td>
                    <td>
                      Eksterni efekti i javno dobro; Opšta ekonomska ravnoteža i
                      ekonomska efikasnost – od mikroekonomije ka
                      makroekonomiji;
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>2P</td>
                    <td>
                      Makroekonomija: Makroekonomski agregati; Agregatna ponuda
                      i agregatna tražnja;
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>2P</td>
                    <td>
                      Novac i inflacija; Budžetski deficit i nacionalni dug;
                      Privredni ciklusi i nezaposlenost; Ekonomski rast;
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>2P</td>
                    <td>Međunarodna ekonomija: Međunarodna trgovina</td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>2P</td>
                    <td>
                      Međunarodni monetarni sistem i međunarodne finansije;
                      Ekonomski razvoj razvijene i nerazvijene zemlje;
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>Kolokvijum II</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>2P</td>
                    <td>
                      Ekonomska teorija: Klasična ekonomija; Neoklasična
                      ekonomija; Kejnzijanizam; Monetarizam; Nova klasična
                      makroekonomija; Savremeni pravci ekonomske teorije.
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>2P</td>
                    <td>
                      Rast razvoj i globalna ekonomija; Evropska unija i
                      evropsko tržište- perspektive investicije fondovi...
                    </td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>2P</td>
                    <td>
                      Nezaposlenost inflacija i ekonomska politika globalni
                      trendovi MMF i druge međunarodne institucije
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 2č / 1.3h</td>
                            <td>Ukupno: 40h</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 2č / 1.3h</td>
                            <td>Nastava + završni ispit: 30h</td>
                          </tr>
                          <tr>
                            <td>Vježbe:</td>
                            <td>Priprema i ovjera semestra: 3oh</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 7h</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default OsnoviEkonomije;
